"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GunCircleFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GunCircleFilled = function GunCircleFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 108 0a8 8 0 000 16z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.704 4.5a.5.5 0 01.49.598l-.3 1.5a.5.5 0 01-.49.402h-2.091c0 1.073-1.056 1.949-2.382 1.998L7.813 9c-.256 0-.503-.03-.736-.088l-.764 2.1-.385 1.147a.5.5 0 01-.474.341h-2.33a.5.5 0 01-.466-.679l1.374-3.583a1 1 0 00-.37-1.184l-.944-.643a.5.5 0 01-.188-.584l.38-1.045c.095-.26.332-.265.641-.282h9.152zM9.813 7H8.494l.035.058a.25.25 0 01-.433.25L7.919 7h-.146l-.524 1.44c.179.039.368.06.564.06 1.119 0 2-.686 2-1.5z",
    fill: "currentColor"
  }));
};

exports.GunCircleFilled = GunCircleFilled;
var _default = GunCircleFilled;
exports.default = _default;